var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-md col-lg-8 col-md-8"},[_c('AddOrganisation',{on:{"submit":_vm.registerChildOrganisation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }